import axios from "axios";
import config from "../config";

const client = axios.create({
  baseURL: config.GOOGLE_MAPS,
  json: true,
});

export default {
  async execute(method, resource, data) {
    return client({
      method,
      url: resource,
      data,
      headers: { "Content-Type": "application/json" },
    }).then((req) => {
      return req.data;
    });
  },
  async getLocationFromZip(zip, key) {
    try {
      return this.execute("get", "geocode/json?address=" + zip + "&key=" + key);
    } catch (err) {
      console.warn(`[getLocationFromZip] ${err}`);
    }
  },
  async getAddressFromLatLng(lat, lng, key) {
    try {
      return this.execute(
        "get",
        "geocode/json?latlng=" + lat + "," + lng + "&key=" + key
      );
    } catch (err) {
      console.warn(`[getAddressFromLatLng] ${err}`);
    }
  },
};
